import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import {
  sendNotificationRequest,
  sendNotificationRequestSuccess,
  sendNotificationRequestError,
} from "../../../slices/teams/members/SendNotificationSlice";

export const SendNotification = (data) => async (dispatch) => {
  try {
    dispatch(sendNotificationRequest());

    const response = await axiosInstance.post(endpoints.sendNotification, data, {
      headers: { "Content-Type": "application/json" },
    });

    dispatch(sendNotificationRequestSuccess(response.data));
    return response.data;
  } catch (error) {
    const _error = {
      data: error?.response?.data?.message || error?.message,
      status: error?.response?.status,
    };
    dispatch(sendNotificationRequestError(_error));
    throw _error;
  }
};
